<template>
	<div>
		<v-dialog
			v-model="showdetailsdialog"
			hide-overlay
			transition="dialog-bottom-transition"
			fullscreen
		>
			<v-card class="details-wrapper">
				<div>
					<v-img
						class="donation-thumbnail theme--dark v-sheet"
						:src="bannerUrl"
						gradient="180deg, rgba(18,30,38,0.2) 0%, rgba(18,30,38,0.9) 70%"
					>
						<div class="details-close-btn">
							<v-btn icon dark @click="closeDetails">
								<v-icon>close</v-icon>
							</v-btn>
						</div>
						<div class="donation-content">
							<div class="donation-content-inner">
								<v-card-title class="d-block">
									<div
										class="d-flex justify-start align-center"
									>
										<div class="logo-area">
											<img :src="logoUrl" />
										</div>
										<div class="">
											<h2 class="donation-title">
												{{ donation.name }}
											</h2>
										</div>
									</div>
								</v-card-title>
							</div>
						</div>
					</v-img>

					<div class="container">
						<div class="donation-details-section">
							<div
								class="subheading donation-details-section-title text-uppercase font-weight-bold"
							>
								<v-icon>list</v-icon>
								{{
									getStateWithParam(
										"donationdetails_description_label"
									)
								}}
							</div>
							<div class="donation-details-section-content">
								{{ donation.detailedDescription }}
							</div>
						</div>

						<v-divider
							v-if="donation.location"
							class="donation-details-section-divider"
						></v-divider>
						<div class="donation-details-section">
							<div
								class="subheading donation-details-section-title text-uppercase font-weight-bold"
							>
								<v-icon>payment</v-icon>
								NIPT
							</div>
							<div class="donation-details-section-content">
								{{ donation.NIPT }}
							</div>
						</div>

						<v-divider
							v-if="donation.location"
							class="donation-details-section-divider"
						></v-divider>

						<div
							v-if="donation.location"
							class="donation-details-section"
						>
							<div
								v-if="donation.location.length > 0"
								class="subheading donation-details-section-title text-uppercase font-weight-bold contact-area"
							>
								{{ getStateWithParam("donation_address") }}
							</div>

							<div
								v-for="(location, index) in donation.location"
								:key="location.locationName"
							>
								<div class="d-flex contact-items">
									<div
										v-if="location.locationName"
										class="subheading d-inline-flex donation-contact name-area"
									>
										<v-icon>domain</v-icon>
										{{ location.locationName }}
									</div>

									<div
										v-if="location.address"
										class="subheading d-inline-flex donation-contact clickable-address-red"
									>
										<v-icon>place</v-icon>
										<div @click="openGoogleMaps">
											{{ location.address }}
										</div>
									</div>

									<!-- Add a divider only if it's not the last location -->
									<div
										v-if="
											index < donation.location.length - 1
										"
										class="donation-details-section-divider"
									></div>
								</div>
							</div>
						</div>

						<v-divider
							v-if="donation.contacts"
							class="donation-details-section-divider"
						></v-divider>
						<div
							v-if="
								donation.contacts &&
								donation.contacts.length > 0
							"
							class="donation-details-section"
						>
							<div
								v-if="donation.contacts.length > 0"
								class="subheading donation-details-section-title text-uppercase font-weight-bold contact-area"
							>
								{{ getStateWithParam("donation_contact") }}
							</div>

							<div
								v-for="(contact, index) in donation.contacts"
								:key="contact.email"
							>
								<div class="d-flex contact-items">
									<div
										v-if="contact.contactTitle"
										class="subheading d-inline-flex donation-contact name-area"
									>
										<v-icon>work</v-icon>
										{{ contact.contactTitle }}
									</div>
									<div
										v-if="contact.contactName"
										class="subheading d-inline-flex donation-contact name-area"
									>
										<v-icon>person</v-icon>
										{{ contact.contactName }}
									</div>

									<div
										v-if="contact.phoneNumber"
										class="subheading d-inline-flex donation-contact call-area"
									>
										<v-icon>call</v-icon>
										<a
											:href="'tel:' + contact.phoneNumber"
											>{{ contact.phoneNumber }}</a
										>
									</div>

									<div
										v-if="contact.email"
										class="subheading d-inline-flex donation-contact clickable-address-red"
									>
										<v-icon>email</v-icon>
										<a :href="'mailto:' + contact.email">{{
											contact.email
										}}</a>
									</div>
								</div>

								<!-- Add a divider only if it's not the last contact -->
								<div
									v-if="index < donation.contacts.length - 1"
									class="donation-details-section-divider my-3"
								></div>
							</div>
						</div>

						<v-divider
							v-if="donation.onlinePresence"
							class="donation-details-section-divider"
						></v-divider>

						<div
							v-if="donation.onlinePresence"
							class="donation-details-section"
						>
							<div
								v-if="donation.onlinePresence"
								class="subheading donation-details-section-title text-uppercase font-weight-bold"
							>
								{{
									getStateWithParam("donation_onlinePresence")
								}}
							</div>

							<div
								class="d-flex contact-items text-decoration-none"
							>
								<div
									v-if="donation.onlinePresence.website"
									class="subheading d-inline-flex donation-contact"
								>
									<v-icon>language</v-icon>
									<a
										:href="
											'https://' +
											donation.onlinePresence.website
										"
										target="_blank"
									>
										{{ donation.onlinePresence.website }}
									</a>
								</div>
								<div
									v-if="donation.onlinePresence.instagram"
									class="subheading d-inline-flex donation-contact"
								>
									<img
										src="../../../assets/icon-others/instagram.png"
										alt=""
										class="mr-2"
										width="22"
										height="22"
									/>
									<a
										:href="
											'https://' +
											donation.onlinePresence.instagram
										"
										target="_blank"
									>
										{{ donation.onlinePresence.instagram }}
									</a>
								</div>
								<div
									v-if="donation.onlinePresence.facebook"
									class="subheading d-inline-flex donation-contact"
								>
									<img
										src="../../../assets/icon-others/facebook.png"
										alt=""
										class="mr-2"
										width="22"
										height="22"
									/>
									<a
										:href="
											'https://' +
											donation.onlinePresence.facebook
										"
										target="_blank"
									>
										{{ donation.onlinePresence.facebook }}
									</a>
								</div>
							</div>
						</div>

						<v-divider
							class="donation-details-section-divider"
						></v-divider>

						<v-btn
							depressed
							class="form-button align-center"
							style=""
							@click.native="goToDonationForm()"
						>
							{{ getStateWithParam("donation_form_button") }}
						</v-btn>
					</div>
				</div>
			</v-card>
			<DonationForm
				:showformdialog="showForm"
				:donationId="this.donationId"
				:donationName="this.donation.name"
			>
			</DonationForm>
		</v-dialog>
	</div>
</template>

<script>
import { API_CLIENT_GET_ID } from "@/config/api/api_call/service_instances";

import { DONATIONS_DETAILS_URL } from "@/config/api/url/urls_in_app";
import DonationForm from "@/views/donations/Donations-details/DonationsForm.vue";
import { BASE_URL } from "@/config/api/url/urls_in_app";
import native_capacitor from "@/config/js_helper/native_capacitor";

export default {
	name: "DonationDetails",
	components: { DonationForm },
	props: {
		showdetailsdialog: { type: Boolean, default: false },
		donationId: {
			type: String,
			default: null,
		},
	},
	data() {
		return {
			donation: [],
		};
	},
	computed: {
		showDetails() {
			return this.$route.name === "donationdetails";
		},
		showForm() {
			return this.$route.name === "donationform";
		},
		logoUrl() {
			if (this.donation.logo) {
				// Return the actual banner URL if it exists
				return BASE_URL + this.donation.logo;
			} else {
				// Return the placeholder image URL if the banner doesn't exist
				return require("../../../assets/img/placeholder.png");
			}
		},
		bannerUrl() {
			if (this.donation.banner) {
				// Return the actual banner URL if it exists
				return BASE_URL + this.donation.banner;
			} else {
				// Return the placeholder image URL if the banner doesn't exist
				return require("../../../assets/img/placeholder.png");
			}
		},
	},
	watch: {
		showdetailsdialog() {
			this.$store.state.active_loader = false;
		},
	},
	mounted() {},
	created() {
		this.getDetails();
	},
	methods: {
		//loader --> false

		getDetails() {
			API_CLIENT_GET_ID(DONATIONS_DETAILS_URL, this.donationId)
				.then((response) => {
					this.donation = response;
					this.$store.state.active_loader = false;
				})
				.catch((err) => {
					this.errorloading = true;
					this.$store.state.active_loader = false;
				});
		},

		closeDetails() {
			//this.$router.push({name: 'citydonations'});
			this.$router.back();
		},

		goToDonationForm() {
			this.$router.push({
				name: "donationform",
			});
		},

		openGoogleMaps() {
			if (this.donation.location && this.donation.location.length > 0) {
				this.donation.location.forEach((location) => {
					const { latitude, longitude } = location;

					// Check if latitude and longitude are defined for the location
					if (latitude !== undefined && longitude !== undefined) {
						const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
						native_capacitor.openUrl(googleMapsUrl);
					} else {
						console.error(
							"Latitude or longitude missing for location:",
							location.locationName
						);
					}
				});
			} else {
				console.error(
					"No location information available for this Foundation."
				);
			}
		},

		getStateWithParam(param) {
			return this.$store.getters.getLanguageParameters(param);
		},
	},
};
</script>

<style lang="scss">
.donation-content {
	display: flex;
	align-items: flex-end;
	height: 100%;
	text-shadow: 0px 0px 50px black;

	.donation-title {
		font-size: 2rem;
		line-height: 1.3;
		text-transform: uppercase;
	}

	.donation-details {
		padding-top: 0 !important;
		font-weight: 400;
		.donation-detail-item {
			display: flex;
			margin-bottom: 3px;
			//align-items: center;
			.donation-detail-icon {
				margin-right: 10px;
			}
			.donation-detail-value {
				padding-top: 2px;
				flex-grow: 1;
			}
		}
	}
}
.donation-serviceType {
	font-size: 1.05em;
	display: inline-block;
	margin-right: 10px;
	font-weight: 500;
	margin-bottom: 5px;
	padding-left: 2px;
	// color: #e60000;
}

.donation-serviceType-title {
	padding-bottom: 12px;
}

.donation-details-section {
	.donation-details-section-title {
		margin-bottom: 16px;
	}
}
.donation-details-section-content .wp-block-embed {
	width: 100%;
	height: 0;
	padding-bottom: 56.25%;
	position: relative;
}
.donation-details-section-content {
	padding-left: 2px;
	p:empty {
		display: none;
	}
	.wp-block-embed__wrapper {
		position: absolute;
		width: 100%;
		height: 100%;
		iframe {
			width: 100% !important;
			height: 100% !important;
		}
	}
}
.donation-details-section-divider {
	margin-bottom: 16px;
}
.donation-details-section {
	padding-bottom: 16px;
}
.details-close-btn {
	position: absolute;
	top: 0;
	right: 0;
}
.bottom-options {
	margin-bottom: 56px;
	.v-btn__content {
		flex-direction: column !important;
	}
}
.details-wrapper > div:not(.v-bottom-nav) {
	padding-bottom: 80px !important;
}

.donation-contact {
	margin-bottom: 5px;
}

.donation-contact i {
	padding-right: 5px;
}

.call-area {
	color: #000 !important;
}

.call-area a {
	color: #000 !important;
	text-decoration: none;
}

.name-area {
	color: #000 !important;
}

.clickable-address-red {
	color: #e60000;
}

.clickable-address-red a {
	text-decoration: none;
}

.text-decoration-none a {
	text-decoration: none;
}

.form-button {
	width: 100%;
	display: flex;
	align-items: center;
	background-color: #e60000 !important;
	margin: 0;
}

.form-button .v-btn__content {
	color: #ffffff !important;
	margin: 0 !important;
}

.contact-items {
	flex-direction: column !important;
	align-items: flex-start !important;
}

.logo-area {
	margin-right: 10px;
}

.logo-area img {
	max-width: 40px;
	border-radius: 4px;
}

.contact-area {
	padding-top: 5px;
}
</style>
